import Layout from "../shared/Layout";
import '../../ComponentsCss/StaticPages.css';
import { useCallback, useEffect, useState } from "react";
import { DeleteStaticPageDescriptionById, GetStaticPage, GetStaticPageDescription, SaveStaticPageDescription } from "../../_services";
import { toast, ToastContainer } from "react-toastify";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';

const StaticPages = () => {
    const [staticPageType, setStaticTypeData] = useState([]);
    const [staticPageData, setStaticPageData] = useState([]);
    const [staticPageDescriptionId, setStaticPageDescriptionId] = useState(0);
    const [selectedStaticPageId, setSelectedStaticPageId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isFormopen, setIsFormopen] = useState(false);

    const [formData, setFormData] = useState({
        staticPageDescriptionId: 0,
        staticPageId: selectedStaticPageId,
        headerName: '',
        description: '',
        isActive: true,
        createdBy: 0
    });

    const resetForm = () => {
        setFormData({
            staticPageDescriptionId: 0,
            staticPageId: selectedStaticPageId,
            headerName: '',
            description: '',
            isActive: true,
            createdBy: 0
        });
        setStaticPageDescriptionId(0);
    }

    const onOpen = () => {
        resetForm();
        setIsFormopen(!isFormopen);
    }

    const StaticPage = async () => {
        try {
            const data = await GetStaticPage();
            setStaticTypeData(data?.data);
        } catch (error) {
            setStaticTypeData([]);
        } finally {
            setLoading(false);
        }
    };

    const StaticPageDescription = useCallback(async () => {
        try {
            const data = await GetStaticPageDescription();

            const filteredData = data?.data?.filter(
                (item) => item.staticPageId === selectedStaticPageId
            );

            setStaticPageData(filteredData);
        } catch (error) {
            setStaticPageData([]);
        } finally {
            setLoading(false);
        }
    }, [selectedStaticPageId]);

    const handlePageSelectChange = (e) => {
        const selectedId = parseInt(e.target.value, 10);

        setSelectedStaticPageId(selectedId);
        // setStaticPageData([]);

        setFormData(prev => ({
            ...prev,
            staticPageId: selectedId,
            headerName: '',
            description: ''
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleDescriptionChange = (value) => {
        setFormData({
            ...formData,
            description: value
        });
    };

    const onSaveStaticPageDescription = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await SaveStaticPageDescription(formData);
            if (data.isSuccess === 200) {
                StaticPageDescription();
                toast.success("Save Successfully");
                setIsFormopen(false);
                resetForm();
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    const onEditStaticPage = (item) => {
        setStaticPageDescriptionId(item?.staticPageDescriptionId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            staticPageDescriptionId: item?.staticPageDescriptionId,
            staticPageId: item?.staticPageId,
            headerName: item?.headerName,
            description: item?.description,
        })
    }

    const DeleteStaticPageDescription = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteStaticPageDescriptionById(id);
        if (data.isSuccess === 1) {
            StaticPageDescription();
            toast.success("Delete Successfully");
        }
    };

    useEffect(() => {
        StaticPage();
    }, []);

    useEffect(() => {
        if (staticPageType.length > 0 && selectedStaticPageId === 0) {
            const defaultId = staticPageType[0].staticPageId;
            setSelectedStaticPageId(defaultId);
            setFormData(prev => ({ ...prev, staticPageId: defaultId }));
        }
    }, [staticPageType, selectedStaticPageId]);

    useEffect(() => {
        if (selectedStaticPageId > 0) {
            StaticPageDescription();
        }
    }, [selectedStaticPageId, StaticPageDescription]);

    const columns = [
        // {
        //     name: 'SR.No',
        //     selector: (row, index) => index + 1,
        //     sortable: false,
        //     width: '80px',
        // },
        // {
        //     name: 'Heading',
        //     selector: row => row.headerName,
        //     sortable: false,
        //     width: '220px'
        // },
        {
            name: 'Description',
            cell: row => (
                <div
                    dangerouslySetInnerHTML={{ __html: row.description }}
                    style={{ whiteSpace: 'normal' }}
                />
            ),
            sortable: false,
            grow: 2,
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' className='edit_icon_wepper' onClick={() => onEditStaticPage(row)}>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' className="delete_icon_weepr" onClick={() => DeleteStaticPageDescription(row.staticPageDescriptionId)}>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false,
            width: '100px'
        }
    ];


    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link'],
            ['image']
        ],
    };

    return (
        <Layout>
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="px-4 static_page_main">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    {/* <div className="admin-heading">
                        <h4 className="mb-0">Static Pages</h4>
                    </div> */}
                    <div className="admin-heading">
                        <h4 className="mb-0">{staticPageData.length > 0 ? staticPageData[0]?.headerName : 'Static Pages'}</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end gap-3">
                        <div className="">
                            <select
                                id="categorySelect"
                                name="staticPageId"
                                className="form-control"
                                value={formData.staticPageId}
                                onChange={handlePageSelectChange}
                            >
                                {/* <option value="">Select a Page</option> */}
                                {Array.isArray(staticPageType) && staticPageType.length > 0 &&
                                    staticPageType.map((item) => (
                                        <option key={item?.staticPageId} value={item?.staticPageId}>
                                            {item?.name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="add_btn">
                            <button onClick={onOpen}>{isFormopen ? 'Close' : 'Add Page'}</button>
                        </div>
                    </div>
                </div>

                {isFormopen && (
                    <div id="entryformContainer" className={`adminform`}>
                        <div className="enForm mt-4">
                            <form onSubmit={onSaveStaticPageDescription} className="row">
                                <div className="form-group">
                                    <label htmlFor="headerName">Page Heading</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="headerName"
                                        name="headerName"
                                        placeholder="Page Heading"
                                        value={formData.headerName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group col-lg-12 mt-3">
                                    <label htmlFor="description">Description</label>
                                    <ReactQuill
                                        value={formData.description}
                                        onChange={handleDescriptionChange}
                                        theme="snow"
                                        modules={modules}
                                        placeholder="Enter description here"
                                        name='description'
                                    />
                                </div>
                                <div className="d-flex form-buttons gap-2">
                                    <div className="submit-btn">
                                        <button type="submit">{`${staticPageDescriptionId ? 'Update' : 'Submit'}`}</button>
                                    </div>
                                    <div className="reset-btn">
                                        <button onClick={resetForm} type="button">Reset</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={staticPageData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        noDataComponent={<p className="text-center mb-0">No data available for the selected page.</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default StaticPages;